import type React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SET_RELOAD_AVATAR } from '../../../store/userAvatar.store';
import './avatar.scss';

interface UserProfileAvatarProps {
  reloadAvatar: boolean;
  userAvatarKey?: string;
  userAvatarUrl?: string;
  newAvatar?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  onImageError?: () => void;
}

const getInitials = (firstName?: string, lastName?: string): string => {
  const first = firstName?.trim().charAt(0).toUpperCase() ?? '';
  const last = lastName?.trim().charAt(0).toUpperCase() ?? '';
  return first + last || '?';
};

const AvatarComponent = (props: UserProfileAvatarProps): React.ReactElement => {
  const dispatch = useDispatch();
  const { userAvatarUrl, reloadAvatar, firstName, lastName, onImageError } =
    props;
  const [avatar, setAvatar] = useState<string | null>(userAvatarUrl ?? null);

  useEffect(() => {
    setAvatar(userAvatarUrl ?? null);
  }, [userAvatarUrl]);

  useEffect(() => {
    if (reloadAvatar) {
      setAvatar(userAvatarUrl ?? null);
      dispatch(SET_RELOAD_AVATAR(false));
    }
  }, [dispatch, reloadAvatar, userAvatarUrl]);

  if (!avatar) {
    return (
      <div className="Avatar__Initials">{getInitials(firstName, lastName)}</div>
    );
  }

  return (
    <img
      className="AVATAR__IMAGE"
      src={avatar}
      alt=""
      onError={() => {
        setAvatar(null);
        onImageError?.();
      }}
    />
  );
};

export default AvatarComponent;
